import { useAuth0 } from '@auth0/auth0-react';
import { Content } from '@carbon/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import './App.scss';

import AppFooter from './components/AppFooter/AppFooter';
import AppNav from './components/AppNav/AppNav';
import BackToTop from './components/BackToTop/BackToTop';
import ProtectedRoute from './components/ProtectedRoute';
import BuildingPortfolio from './content/BuildingPortfolio/BuildingPortfolio';
import BuildingReport from './content/BuildingReport/BuildingReport';
import Dashboard from './content/Dashboard/Dashboard';

import ReportDateContext from './ReportDateContext';

function App() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  const navigate = useNavigate();
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [useActual, setUseActual] = useState(false);
  const [selectedReport, setSelectedReport] = useState({});
  const [availableReports, setAvailableReports] = useState([]);

  window.onpopstate = () => navigate("/"); // Always return to main page when pressing the back button

  useEffect(() => {
    const getReports = async () => {
      try {
        if (isAuthenticated) {
          const accessToken = await getAccessTokenSilently();
          const { data } = await axios.get(
            `${process.env.REACT_APP_API_SERVER_URL}/list/building_report/all/0`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          );

          setAvailableReports(data);
          setSelectedReport(data[0]);
          setYear(data[0].year);
          setMonth(data[0].month);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getReports();
  }, [isAuthenticated, getAccessTokenSilently]);

  const setReportDate = reportDate => {
    setSelectedReport(reportDate);
    setYear(reportDate.year);
    setMonth(reportDate.month);
  };

  return (
    <div className="App">
      <ReportDateContext.Provider value={{ year, month, useActual, selectedReport, availableReports, setReportDate, setUseActual }}>
        <AppNav />
        <Content>
          <Routes>
            <Route path="/" element={<ProtectedRoute component={Dashboard} />} />
            <Route path="/building_portfolio" element={<ProtectedRoute component={BuildingPortfolio} />} />
            <Route path="/building_report" element={<ProtectedRoute component={BuildingReport} />} />
          </Routes>
        </Content>
        <BackToTop />
        <AppFooter />
      </ReportDateContext.Provider>
    </div>
  );
}

export default App;
